import { CollectionResponse, fetchCollectionProducts } from 'api/product';
import SimpleHeadline from 'components/simple-headline';
import { useConfig } from 'config';
import { usePetContext } from 'contexts/pet';
import { useMemo } from 'react';
import useSWR from 'swr';
import CollectionSectionBestseller from '../collection-section-bestseller';

type SpecialAndLimitedEditionSliderProps = {
  collectionHandle?: string;
  elementNameTracking: string;
  title?: string;
};

const COLLECTION_CAT_HANDLE = 'home-page-special-katzen';
const COLLECTION_DOG_HANDLE = 'home-page-special-hunde';

/**
 * Special and limited edition slider. Fetches products from a collection.
 * Component is used on the dog and cat landing pages.
 */
const SpecialAndLimitedEditionSlider: React.FC<
  SpecialAndLimitedEditionSliderProps
> = ({ title, collectionHandle, elementNameTracking }) => {
  const { current } = usePetContext();
  const { shopId } = useConfig();
  const _collectionHandle = useMemo(() => {
    if (collectionHandle) {
      return collectionHandle;
    }
    return current === 'dogs' ? COLLECTION_DOG_HANDLE : COLLECTION_CAT_HANDLE;
  }, [collectionHandle, current]);

  const { data: upsellProducts, isValidating } = useSWR<CollectionResponse>(
    _collectionHandle,
    (handle) => fetchCollectionProducts(handle, shopId, true)
  );

  if (isValidating || !upsellProducts) return null;

  return (
    <>
      {title && <SimpleHeadline title={title} className="mb-2" />}

      <CollectionSectionBestseller
        collection={_collectionHandle}
        elementNameTracking={[elementNameTracking]}
        sliderSize="large"
        staticCollection={upsellProducts}
      />
    </>
  );
};

export default SpecialAndLimitedEditionSlider;
